import { useAtom } from 'jotai';
import persistentAtom from 'shared/atoms/persistent-atom';

const userProjectionAtom = persistentAtom<{ [key: string]: string[] } | null>('userProjection', null);

const useUserProjection = () => {
  const [userProjection, setUserProjection] = useAtom(userProjectionAtom);
  return { userProjection, setUserProjection };
};

export default useUserProjection;
